import { render } from "./BaseLabel.vue?vue&type=template&id=38a477d9&scoped=true"
import script from "./BaseLabel.js?vue&type=script&lang=js"
export * from "./BaseLabel.js?vue&type=script&lang=js"

import "./BaseLabel.scss?vue&type=style&index=0&id=38a477d9&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a477d9"]])

export default __exports__